import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Film } from "lucide-react";

const links = [
  { href: "#lavori", label: "Lavori" },
  { href: "#pacchetti", label: "Pacchetti" },
  { href: "#processo", label: "Processo" },
  { href: "#testimonianze", label: "Clienti" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [location]);

  return (
    <>
      <header
        data-testid="site-nav"
        className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
          scrolled ? "glass py-3" : "py-5 bg-transparent"
        }`}
      >
        <div className="container-x flex items-center justify-between">
          <Link to="/" data-testid="brand-logo" className="flex items-center gap-2 group">
            <Film strokeWidth={1.5} className="w-5 h-5 text-gold" />
            <span className="font-display text-lg tracking-tight">
              Falco<span className="text-gold"> Poulo</span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.label.toLowerCase()}`}
                className="text-sm text-white/70 hover:text-white transition-colors"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <a data-testid="nav-cta-desktop" href="#preventivo" className="btn-gold text-sm py-2.5">
              Richiedi preventivo
            </a>
          </div>

          <button
            data-testid="nav-menu-toggle"
            className="md:hidden text-white p-2"
            onClick={() => setOpen(true)}
            aria-label="Apri menu"
          >
            <Menu strokeWidth={1.5} className="w-6 h-6" />
          </button>
        </div>
      </header>

      {/* Mobile overlay menu */}
      <div
        className={`fixed inset-0 z-[60] bg-graphite-950 transition-all duration-500 ${
          open ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
        }`}
      >
        <div className="container-x pt-6 flex items-center justify-between">
          <span className="font-display text-lg">
            Falco<span className="text-gold"> Poulo</span>
          </span>
          <button
            data-testid="nav-menu-close"
            className="p-2"
            onClick={() => setOpen(false)}
            aria-label="Chiudi menu"
          >
            <X strokeWidth={1.5} className="w-6 h-6" />
          </button>
        </div>
        <nav className="container-x mt-16 flex flex-col gap-6">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-${l.label.toLowerCase()}`}
              className="font-display text-4xl tracking-tight text-white hover:text-gold transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            onClick={() => setOpen(false)}
            data-testid="nav-cta-mobile"
            href="#preventivo"
            className="btn-gold mt-8 w-fit"
          >
            Richiedi preventivo
          </a>
        </nav>
      </div>
    </>
  );
}
